import { Alert, Typography } from "antd";

export const parseCSVLine = (line) => {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      result.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  result.push(current);
  return result;
};

export const parseCSV = (content, fields) => {
  const lines = content.trim().split("\n");
  const headers = lines[0].split(",").map((h) => h.trim());
  const expectedFieldNames = fields.map((f) => f.name);
  const errors = [];

  const invalidHeaders = headers.filter((h) => !expectedFieldNames.includes(h));
  const missingHeaders = expectedFieldNames.filter(
    (name) => !headers.includes(name)
  );

  if (invalidHeaders.length)
    errors.push(`Invalid headers: ${invalidHeaders.join(", ")}`);
  if (missingHeaders.length)
    errors.push(`Missing headers: ${missingHeaders.join(", ")}`);

  const data = [];

  for (let i = 1; i < lines.length; i++) {
    if (!lines[i].trim()) continue;
    const values = parseCSVLine(lines[i]);
    if (values.length !== headers.length) {
      errors.push(`Row ${i} has incorrect number of columns`);
      continue;
    }

    const rowData = {};
    headers.forEach((header, index) => {
      rowData[header] = values[index];
    });

    validateRow(rowData, i, fields, errors);
    data.push(rowData);
  }

  return { data, errors };
};

const validateRow = (rowData, rowIndex, fields, errors) => {
  fields.forEach(({ name, schema, itype }) => {
    const value = rowData[name];

    if (!value && schema.required) {
      errors.push(`Row ${rowIndex}: Missing required field "${name}"`);
      return;
    }
    if (itype === "img") {
      // For image fields, just make sure there's a value if required
      if (!value && schema?.required) {
        errors.push(`Row ${rowIndex}: Missing required image for "${name}"`);
      }
      // Skip the rest of the validation for image fields
      return;
    }
    switch (itype) {
      case "number":
        if (isNaN(parseFloat(value))) {
          errors.push(`Row ${rowIndex}: "${name}" should be a number`);
        }
        break;
      case "date":
        if (isNaN(Date.parse(value))) {
          errors.push(`Row ${rowIndex}: "${name}" should be a date`);
        }
        break;
      case "boolean":
        if (!["true", "false", "0", "1"].includes(value.toLowerCase())) {
          errors.push(`Row ${rowIndex}: "${name}" should be boolean`);
        }
        break;
    }

    // if (schema.enum && !schema.enum.includes(value)) {
    //   errors.push(
    //     `Row ${rowIndex}: "${name}" must be one of ${schema.enum.join(", ")}`
    //   );
    // }

    // if (schema.pattern && !new RegExp(schema.pattern).test(value)) {
    //   errors.push(`Row ${rowIndex}: "${name}" does not match pattern`);
    // }
  });
};
export const ValidationErrorList = ({ errors }) => {
  const errorList = Array.isArray(errors) ? errors : [errors];
  return (
    <Alert
      message=" Validation Failed"
      description={
        <ul
          style={{
            maxHeight: "200px",
            overflow: "auto",
            margin: 0,
            paddingLeft: "20px",
          }}
        >
          {errorList.map((error, index) => (
            <li key={index}>
              {/* Handle both string errors and error objects */}
              {typeof error === "string"
                ? error
                : error.message || JSON.stringify(error)}
            </li>
          ))}
        </ul>
      }
      type="error"
      showIcon
      style={{ marginBottom: 20 }}
    />
  );
};
